export const FORUM_DM_PENDING_KEY = 'ql7_user_dm_open_after_forum_v1'

export function normalizeForumDmUserId(value) {
  return String(value || '').trim()
}

export function buildForumDmHref(userId) {
  const uid = normalizeForumDmUserId(userId)
  if (!uid) return '/forum'
  const params = new URLSearchParams({ inbox: 'messages', dmUser: uid })
  return `/forum?${params.toString()}`
}

export function isForumDmDeepLinkSearch(search = '') {
  try {
    const params = new URLSearchParams(String(search || ''))
    return params.get('inbox') === 'messages' && !!normalizeForumDmUserId(params.get('dmUser'))
  } catch {
    return false
  }
}

export function writePendingForumDmUserId(userId) {
  const uid = normalizeForumDmUserId(userId)
  if (!uid) return ''
  try {
    if (typeof window !== 'undefined') window.sessionStorage?.setItem(FORUM_DM_PENDING_KEY, uid)
  } catch {}
  return uid
}

export function readPendingForumDmUserId() {
  try {
    if (typeof window === 'undefined') return ''
    return normalizeForumDmUserId(window.sessionStorage?.getItem(FORUM_DM_PENDING_KEY))
  } catch {
    return ''
  }
}

export function clearPendingForumDmUserId() {
  try {
    if (typeof window !== 'undefined') window.sessionStorage?.removeItem(FORUM_DM_PENDING_KEY)
  } catch {}
}
